import React, { useState } from "react";
import { ListaCanciones } from "./components/ListaCanciones";
import { VistaCancion } from "./components/VistaCancion";
import { useCancionSincronizada } from "./hooks/useCancionSincronizada";
import canciones from './data/canciones.js'
import "./App.css";

export default function App() {
  // cancionEmitida: la que Firebase tiene activa → la ven TODOS
  const { cancionEmitida, cargando, emitirCancion, limpiarEmision } =
    useCancionSincronizada();

  // cancionLocal: la que estoy explorando YO en mi dispositivo
  const [cancionLocal, setCancionLocal] = useState(null);

  // La pantalla principal muestra: si estoy explorando → la local; si no → la emitida
  const cancionEnPantalla = cancionLocal ?? cancionEmitida;

  const [modoAcordes, setModoAcordes] = useState(false);
  const [panelAbierto, setPanelAbierto] = useState(true);
  const [categoriaFiltro, setCategoriaFiltro] = useState(null);

  // Cuando se pulsa una categoría en VistaCancion: abre el panel y filtra
  const handleCategoriaClick = (cat) => {
    setCategoriaFiltro(cat);
    setPanelAbierto(true);
  };

  // ¿La canción que veo en mi pantalla ya está emitida a todos?
  const yaEstaEmitida =
    cancionLocal !== null && cancionEmitida?.id === cancionLocal?.id;

  if (cargando) {
    return (
      <div className="pantalla-carga">
        <div className="carga-spinner" />
        <p>Conectando al cancionero…</p>
      </div>
    );
  }

  const handleSeleccionarLocal = (c) => {
    setCancionLocal(c);
    if (window.innerWidth < 900) setPanelAbierto(false);
  };

  const handleEmitir = () => {
    if (cancionLocal) {
      emitirCancion(cancionLocal);
      setCancionLocal(null); // vuelve a seguir la emisión
    }
  };

  const handleLimpiar = () => {
    limpiarEmision();
    setCancionLocal(null);
  };

  // Descarta la previsualización local y vuelve a ver la emitida
  const handleCancelarPreview = () => {
    setCancionLocal(null);
  };

  return (
    <div className={`app-layout ${panelAbierto ? "panel-visible" : "panel-oculto"}`}>
      {/* ── Sidebar con lista ── */}
      <ListaCanciones
        cancionEmitida={cancionEmitida}
        cancionLocal={cancionLocal}
        onSeleccionar={handleSeleccionarLocal}
        categoriaExterna={categoriaFiltro}
        onCategoriaExterna={setCategoriaFiltro}
      />

      {/* ── Área principal ── */}
      <main className="area-principal">
        <header className="barra-herramientas">
          <button
            className="btn-icono"
            onClick={() => setPanelAbierto(!panelAbierto)}
            title="Mostrar/ocultar lista"
          >
            {panelAbierto ? "✕" : "☰"}
          </button>

          <div className="barra-centro">
            {cancionEmitida && !cancionLocal && (
              <span className="barra-cancion-activa">
                📡 {cancionEmitida.titulo}
              </span>
            )}
            {cancionLocal && (
              <span className="barra-cancion-preview">
                👁 Vista previa: {cancionLocal.titulo}
              </span>
            )}
          </div>

          <div className="barra-acciones">
            <button
              className={`btn-modo ${modoAcordes ? "activo" : ""}`}
              onClick={() => setModoAcordes(!modoAcordes)}
            >
              {modoAcordes ? "🎸 Acordes" : "📖 Letra"}
            </button>

            {/* Botón cancelar preview */}
            {cancionLocal && (
              <button className="btn-cancelar-preview" onClick={handleCancelarPreview}>
                Cancelar
              </button>
            )}

            {/* Botón principal: Emitir a todos */}
            {cancionLocal && !yaEstaEmitida && (
              <button className="btn-emitir" onClick={handleEmitir}>
                📡 Emitir a todos
              </button>
            )}

            {/* Limpiar pantalla global */}
            {cancionEmitida && !cancionLocal && (
              <button className="btn-limpiar" onClick={handleLimpiar}>
                Limpiar pantalla
              </button>
            )}
          </div>
        </header>

        {/* Banner de aviso cuando hay preview activa */}
        {cancionLocal && (
          <div className="banner-preview">
            <span>Solo tú ves esta canción.</span>
            <strong>Pulsa "Emitir a todos" para que aparezca en todos los dispositivos.</strong>
          </div>
        )}

        {/* Contenido principal */}
        <div className="contenido-cancion">
          {cancionEnPantalla ? (
            <VistaCancion cancion={cancionEnPantalla} modoAcordes={modoAcordes}
              onCategoriaClick={handleCategoriaClick} />
          ) : (
            <div className="pantalla-vacia">
              <div className="vacia-icono">🎼</div>
              <h2>Ninguna canción seleccionada</h2>
              <p>Selecciona una canción de la lista para previsualizarla.<br />
              Cuando estés listo, pulsa <strong>"Emitir a todos"</strong>.</p>
            </div>
          )}
        </div>

        <div className="sync-badge">
          <span className="sync-dot" />
          En directo
        </div>
      </main>
    </div>
  );
}
